module.exports = __webpack_public_path__ + "img/sp_foot_ico02.410d418f.svg";